import { type ValueFormat } from '../types'

export const getValueFormatter = (format?: ValueFormat): ((_value: number) => string) => {
  if (!format) {
    return (value) => String(value)
  }

  switch (format) {
    case 'percent':
      return (value) => `${String(value)}%`

    case 'currency':
      return (value) => {
        if (Math.abs(value) >= 1e6) {
          return `$${(value / 1e6).toFixed(1)}M`
        }
        if (Math.abs(value) >= 1e3) {
          return `$${(value / 1e3).toFixed(1)}K`
        }
        return `$${value.toFixed(2)}`
      }

    case 'number':
      return (value) => {
        if (Math.abs(value) >= 1e9) {
          return `${(value / 1e9).toFixed(1)}B`
        }
        if (Math.abs(value) >= 1e6) {
          return `${(value / 1e6).toFixed(1)}M`
        }
        if (Math.abs(value) >= 1e3) {
          return `${(value / 1e3).toFixed(1)}K`
        }
        return String(Math.round(value))
      }

    case 'decimal':
      return (value) => value.toFixed(2)

    default:
      return (value) => String(value)
  }
}


// Helper function to determine if labels should be rotated
export const shouldRotateLabels = (dataLength: number, threshold = 7) => {
  return dataLength > threshold
}

// Helper function to calculate smart tick interval
export const getTickInterval = (dataLength: number, maxTicks = 10) => {
  if (dataLength <= maxTicks) return 0 // Show all ticks
  return Math.ceil(dataLength / maxTicks)
}

// Helper function to truncate long labels
export const truncateLabel = (label: string, maxLength = 15) => {
  if (typeof label !== 'string') return label
  if (label.length <= maxLength) return label
  return `${label.substring(0, maxLength - 3)}...`
}

// Helper function to format axis labels dynamically
export const formatAxisLabel = (value: any, dataLength: number) => {
  // For large datasets, truncate labels
  if (dataLength > 20) {
    return truncateLabel(String(value), 10)
  }
  if (dataLength > 10) {
    return truncateLabel(String(value), 15)
  }
  return value
}